const CONTAINER_ID = "notifications-container";

const ANIMATION_DURATION_MS = 500;
const DEFAULT_NOTIFICATION_DURATION_MS = 4000;

const CONTAINER_CLASSES = [
  "fixed",
  "top-15",
  "right-0",
  "px-3",
  "w-full",
  "text-center",
  "md:text-left",
  "md:max-w-md",
  "z-50",
  "empty:hidden",
];

const DEFAULT_NOTIFICATION_CLASSES = [
  "font-sans",
  "font-medium",
  "px-5",
  "py-4",
  "mt-2",
  "rounded-lg",
  "shadow-default",
  "animate-fade",
  "animate-duration-500",
];

const SUCCESS_CLASSES = ["bg-gray-600", "text-white"];
const WARNING_CLASSES = ["bg-orange-500", "text-white"];
const ERROR_CLASSES = ["bg-red-600", "text-white"];

class Notifier {
  container: HTMLElement;

  constructor() {
    this.container = this.initContainer();
  }

  success(message: string): void {
    this.show(message, SUCCESS_CLASSES);
  }

  warning(message: string): void {
    this.show(message, WARNING_CLASSES);
  }

  error(message: string): void {
    this.show(message, ERROR_CLASSES);
  }

  private show(message: string, classes: string[]) {
    const notification = document.createElement("div");
    notification.classList.add(...DEFAULT_NOTIFICATION_CLASSES);
    notification.classList.add(...classes);

    notification.innerText = message;

    this.container.prepend(notification);

    setTimeout(() => {
      notification.classList.add("animate-fade", "opacity-0");

      setTimeout(() => {
        notification.remove();
      }, ANIMATION_DURATION_MS);
    }, DEFAULT_NOTIFICATION_DURATION_MS);
  }

  private initContainer() {
    const existing = document.getElementById(CONTAINER_ID);
    if (existing) {
      return existing;
    }

    const element = document.createElement("div");
    element.id = CONTAINER_ID;
    element.classList.add(...CONTAINER_CLASSES);

    document.body.appendChild(element);

    return element;
  }
}

export default new Notifier();
